import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const createWinlossService = async (payload, signal) => {
    console.log(signal, 'signal in service');
    return (await axiosInstance.post(APIROUTE.winloss, payload, { signal })).data;
};

export const getAgentDetailsService = async (gameTypeId, calculationDate, signal) => {
    return (await axiosInstance.get(`${APIROUTE.winloss}/agent-details?gameTypeId=${gameTypeId}&&${calculationDate}`, signal)).data;
}

export const getWinLossService = async (gameTypeId, calculationDate, signal) => {
    return (await axiosInstance.get(`${APIROUTE.winloss}/get-all-agent-details/gameTypeId/${gameTypeId}/calculationDate/${calculationDate}`, signal)).data;
}

export const getGameTypeEquationByWinlossIdService = async (Id, signal) => {
    let winlossId = Id.id;
    return (await axiosInstance.get(`${APIROUTE.winloss}/${winlossId}`, signal)).data;
}

export const updateWinLossService = async (payload) => {
    let filteredPayload = {
        "siteData": payload.siteData,
        "winLoss": payload.winLoss,
        "agentId": payload.agentId,
        "userId": payload.userId
    }
    return (await axiosInstance.put(`${APIROUTE.winloss}/${payload.winLossId}`, filteredPayload)).data;
}

export const getUserWinLossByDateService = async (payload, userId) => {

    return (await axiosInstance.post(`${APIROUTE.profitShare}/${userId}`, payload)).data;
}

export const getWinLossAllGameTypeByDateService = async (payload) => {

    return (await axiosInstance.post(`${APIROUTE.winLossAllGameType}`, payload)).data;
}

export const getWinLossTotal = async () => {

    return (await axiosInstance.get(`${APIROUTE.winLossTotal}`)).data;
}


// export const deleteEquationBywinlossGameTypeService = async (winlossId, gameTypeId) => {
//     return (await axiosInstance.delete(`${APIROUTE.currency}/${currencyId}`)).data
// }
